export default {"src":"/_next/static/media/downsize.9da73b56.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};